import { useTranslation } from "react-i18next";
import { GitCompare } from "lucide-react";
import { ComparedPlanSelect } from "../ComparedPlanSelect";
import type { ComparedPlanEmptyStateProps } from "./types";

export const ComparedPlanEmptyState = ({
  candidateRecords,
  onComparedPlanSelect,
}: ComparedPlanEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full max-w-md flex-col items-center gap-4">
      <div className="rounded-full bg-gray-100 p-4 text-gray-500">
        <GitCompare size={28} />
      </div>
      <p className="text-sm text-gray-600">
        {t("smartSurveyor.planComparison.selectPrompt")}
      </p>
      <ComparedPlanSelect
        candidateRecords={candidateRecords}
        comparedPlanRecord={null}
        onComparedPlanSelect={onComparedPlanSelect}
        className="w-full"
      />
    </div>
  );
};
